import React, { useEffect, useRef, useState } from "react";
import { baseUrl } from '../../config.js'
import { Link, useParams, useNavigate } from 'react-router-dom';
import Modal from '../Modal/Modal.js';
import { Documentos } from '../Persona/Persona.js';
import { DocumentosAlmacen, FotosAlmacen } from '../InfoAlmacen/InfoAlmacen.js';
import { formatoMoneda, idsRC, nombres, Imagenes, idServiciosR, idsR } from "../../almacen.js";

import useToken from '../../useToken';

import './Publicacion.css';

import Checked from '../../img/Checked.png';
import Cerrar from '../../img/Cerrar.png';
import Info from '../../img/Info.png';

const Publicacion = ({id_publicacion})=>{

	const navigate = useNavigate();
	const {token} = useToken();
	const [config, setConfig] = useState(localStorage.getItem('config') ? JSON.parse(localStorage.getItem('config')) : {
	  idioma : 'es',
	  sistema : 'internacional',
	})
	const { id, idPost = id_publicacion } = useParams();
	const [paso, setPaso] = useState('Información');
	const [almacen, setAlmacen] = useState({idCompany:0, direccion:{}});
	const [detalles, setDetalles] = useState(false);
	const [persona, setPersona] = useState({});
	const [ocupados, setOcupados] = useState(0);
	const [inicial, setInicial] = useState(0);
	const [terminos, setTerminos] = useState([]);
	const [times, setTimes] = useState({
		"1" : {
			active: false,
			price: 0,
			min: 0,
			max: 0,
			credit: 0,
		},
		"2" : {
			active: false,
			price: 0,
			min: 0,
			max: 0,
			credit: 0,
		},
		"3" : {
			active: true,
			price: 0,
			min: 0,
			max: 0,
			credit: 0,
		},
		"4" : {
			active: false,
			price: 0,
			min: 0,
			max: 0,
			credit: 0,
		},
	});
	const [reembolso, setReembolso] = useState(100);
	const [publicacion, setPublicacion] = useState({typeOfStores:[], TypeTime : []});
	const [desglose, setDesglose] = useState({});
	const [status, setStatus] = useState(0);
	const [info, setInfo] = useState('');
	const [disabled, setDisabled] = useState(false);
	const [inmediata, setInmediata] = useState(false);
	const [personas, setPersonas] = useState([]);
	const [archivos, setArchivos] = useState({});
	const [photos, setPhotos] = useState({});
	const [totalFotos, setTotalFotos] = useState(0);
	const [eliminarFotos, setEliminarFotos] = useState([]);
	const [docsAlmacen, setDocsAlmacen] = useState({});
	const [archivosInvalidos, setArchivosInvalidos] = useState({persona: [], almacen: []});
	const [subiendo, setSubiendo] = useState({
		total : 0,
		subidas : 0,
		archivosSubidos : 0,
		totalArchivos : 0,
	});
	const [float, setFloat] = useState({});
	const [floatModal, setFloatModal] = useState({});
	const [modal, setModal] = useState('');
	const refTimes = useRef([]);
	const divDesc = useRef();

	const facturacion = {
		"1" : "Semanal",
		"2" : "Semanal",
		"3" : "Mensual",
		"4" : "Anual",
	}

	const periodos = [
		{
			"nombre" : "Día", 
			"key" : "day", 
			"id" : "1"
		},
		{
			"nombre" : "Semana", 
			"key" : "week", 
			"id" : "2"
		},
		{
			"nombre" : "Mes", 
			"key" : "month", 
			"id" : "3"
		},
		{
			"nombre" : "Año", 
			"key" : "year", 
			"id" : "4"
		},
	]

	const lbls = {
		"-1" : "Faltante",
		"3" : "Rechazado",
		"6" : "En Revisión",
	}
	const clases = {
		"-1" : "SinSubir",
		"3" : "Rechazado",
		"6" : "Revision",
	}

	useEffect(()=>{
		getTerminos();
		if(token)
            getData();
		getEmpresas();
	}, [idPost, token])

	useEffect(()=>{
		setPersona({...persona})
	}, [modal])

	useEffect(()=>{
		let total = 0;
		for(let k in photos){
			total+= photos[k].length;
		}
		setTotalFotos(total);
	}, [photos])

	useEffect(()=>{
		desglosar();
	},[publicacion, times])

	const handleClickOutside = (event) => {
        if (divDesc.current && !divDesc.current.contains(event.target)) {
            setInfo(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

	useEffect(()=>{
		const aux = {"persona": [], "almacen": []};
		Object.keys(aux).forEach(tipo=>{
			const arreglo = tipo == "persona" ? persona?.DocumentCompany || [] : almacen?.Document || [];
			console.log({arreglo})
			arreglo.forEach(doc=>{
				console.log({doc})
				if(!doc.idStatusDocument){
					doc.idStatusDocument = '-1';
				}
				if(
					(doc.idDocument == 32 && !publicacion.typeOfStores.includes('11')) ||
					(doc.idDocument == 33 && !publicacion.typeOfStores.includes('5')) ||
					(doc.idDocument == 35 && !publicacion.typeOfStores.includes('9')) ||
					(doc.idDocument == 44 && !persona?.OperativeService?.includes('17')) ||
					(doc.idDocument == 45 && !persona?.OperativeService?.includes('18')) ||
					(doc.idDocument == 37 && persona.TypeCompany == 'Persona fisica')
				){
					return false;
				}
				if(doc.requiredStore == 'required' && doc.idStatusDocument != 4 && tipo == "almacen"){
					aux["almacen"].push(doc);
				}
				else if(doc.requiredCompany == 'required' && doc.idStatusDocument != 4 && tipo == "persona"){
					aux["persona"].push(doc);
				}
			})
		})
		console.log({aux})
		setArchivosInvalidos(aux);

	}, [persona, publicacion])

	useEffect(()=>{
		let periodo = 0;
		let valor = 0;
		if(refTimes.current[2]){
			periodo = 2;
			valor = refTimes.current[2].value || publicacion?.month;
		}
		else{
			for(let i = 0; i <= 3; i++){
				if(refTimes.current[i]){
					periodo = i;
					valor = refTimes.current[i].value;
				}
			}
		}
		if(periodo && publicacion?.idPost){
			sugerir(periodo, valor);
		}
	}, [times, publicacion])

	async function getData(){
		const result = await fetch(baseUrl+"Store/"+id,{
			headers:{
				'Authorization': `Bearer ${token}`,
			}
		})
		.then(response=>response.json())
		.then(json=>{
			return json;
		})
		.catch(error=>{
			console.error(error);
		})
		
		let result1;
		if(idPost){
			result1 = await fetch(baseUrl+"Post/"+idPost,{
					headers:{
						'Authorization': `Bearer ${token}`,
					}
				})
			.then(response=>response.json())
			.then(json=>{
				return json;
			})
			.catch(error=>{
				console.error(error);
			})
		}
		if(result1?.success){
			if(config.sistema == 'ingles'){
				result1.data.width = (result1.data?.width || 0)*(3.2808399)/100;
				result1.data.length = (result1.data?.length || 0)*(3.2808399)/100;
				result1.data.height = (result1.data?.height || 0)*(3.2808399)/100;
				result1.data.weight = (result1.data?.weight || 0)*(2.20462262);
			}
			setPublicacion({typeOfStores:[], TypeTime: [], width : 100, length:100, ...result1?.data} || {});
			setReembolso(result1?.data?.refund || 0)
			setStatus(result1?.data?.status || 0)
			setTimes(Object.keys(result1?.data?.TypeTime).length != 0 ? {...times, ...result1.data.TypeTime} : {...times})
			setInmediata(result1?.data?.inmediate);
		}
		const result2 = await fetch(baseUrl+"Store/"+id+"/totalAssignedSpaces",{
			headers:{
				'Authorization': `Bearer ${token}`,
			}
		})
		.then(response=>response.json())
		.then(json=>{
			return json;
		})
		.catch(error=>{
			console.error(error);
		})
		result.documentsData = result?.DocumentCompany;
		setPersona(result)
		setDocsAlmacen(result?.Document);

		const auxArchivos = {};
		result.Document?.forEach(document=>{
			auxArchivos[document.idDocument] = document;
		})
		setArchivos(auxArchivos);

		const auxPhotos = {};
		result.Photos?.forEach(photo=>{
			if(!auxPhotos[photo.idCategoryPhoto])
				auxPhotos[photo.idCategoryPhoto] = [];
			auxPhotos[photo.idCategoryPhoto].push(photo);
		})
		setPhotos(auxPhotos);
		result.tipos = {};
		result?.TypeStore?.forEach(x=>{
			result.tipos[idsR[x]] = true;
		})
		result.servicios = {};
		result?.OperativeService?.forEach(x=>{
			result.servicios[idServiciosR[x]] = true;
		})
		setAlmacen({idCompany:0, direccion:{}, tipos:{}, servicios:{}, ...result} || {idCompany:0, direccion:{}, tipos:{}, servicios:{}});
		console.log(result1)
		if(result1?.data?.inmediate){
			setOcupados(result2?.totalAssignedSpaces*1 || 0)
		}
		else{
			setOcupados(result2?.totalAssignedConfirmSpaces*1 || 0)
		}
		setInicial(result1?.data?.assignedSpaces*1 || 0)
	}

	const getTerminos = async ()=>{
		const result = await fetch(baseUrl+"Terms", {
			headers:{
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'Authorization': `Bearer ${token}`,
			}
		})
		.then(response=>response.json())
		.then(json=>{
			return json;
		})
		.catch(error=>{
			console.error(error);
		})
		setTerminos(result?.data);
	}

	const getEmpresas = async ()=>{
		const result = await fetch(baseUrl+"User/Companies/", {
			headers:{
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'Authorization': `Bearer ${token}`,
			}
		})
		.then(response=>response.json())
		.then(json=>{
			// console.log(json);
			return json;
		})
		.catch(error=>{
			console.error(error);
		})
		setPersonas(result?.data);
	}

	const guardar = async (e)=>{
		setFloat({estado:'guardando', mensaje:'Guardando...'})
		if(publicacion.assignedSpaces > (isNaN(inicial*1 + (inmediata ? almacen?.availableSpace : almacen?.availableConfirmSpace)*1 - ocupados) ? 0 : inicial*1 + (inmediata ? almacen?.availableSpace : almacen?.availableConfirmSpace)*1 - ocupados)){
			setFloat({estado:'error', mensaje:'El número de espacios asignados excede los espacios disponibles'});
			setTimeout(() => {
				setFloat({});
			}, 5000);
			return false;
		}
		publicacion.idStore = id;
		publicacion.TypeTime = times;
		publicacion.refund = reembolso;
		if(config.sistema == 'ingles'){
			publicacion.width = publicacion.width*100/3.2808399;
			publicacion.length = publicacion.length*100/3.2808399;
			publicacion.height = publicacion.height*100/3.2808399;
			publicacion.weight = publicacion.weight/2.20462262;
		}
		const data = {
			...publicacion,
		}
		const accion = idPost ? "put" : "post";
		if(idPost){
			data["idPost"] = idPost;
		}
		// return false;
		const result = await fetch(baseUrl+"Post", {
			method: accion,
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'Authorization': `Bearer ${token}`,
			},
			body: JSON.stringify(data),
		})
		.then(response=>response.json())
		.then(json=>{
			return json;
		})
		.catch(error=>{
			console.error(error);
			setFloat({})
		})
		if(result?.success){
			setFloat({estado:'listo', mensaje:'¡Listo! Se han guardado los cambios con éxito'})
			if(!idPost)
				navigate('/host/gestion/publicaciones/'+id+'/'+result.id, {replace: true})
			setTimeout(() => {
				setFloat({});
			}, 5000);
		}
		else{
			setFloat({estado:'error', mensaje:result?.error})
			setTimeout(() => {
				setFloat({});
			}, 5000);
		}
	}
	const cambiarStatus = (status = 0)=>{
		const data = {
			idPost,
			status,
		}
		fetch(baseUrl+"StatusPost", {
			method: "put",
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'Authorization': `Bearer ${token}`,
			},
			body: JSON.stringify(data),
		})
		.then(response=>response.json())
		.then(json=>{
			setStatus(status);
			return json;
		})
		.catch(error=>{
			console.error(error);
			setFloat({})
		})
	}
	const sugerir = (periodo, costo)=>{
		console.log(periodo, costo)
		const rel = [1,7,30,365];
		const names = ["day", "week", "month", "year"];
		const costoDia = costo/rel[periodo];
		console.log(refTimes.current[periodo])
		refTimes.current[periodo].parentNode.className = "";
		for(let i = 0; i < 4; i++){
			if(refTimes.current[i]){
				if(refTimes.current[i].value == "" || refTimes.current[i].value == 0 || refTimes.current[i].parentNode.className == "sugerido"){
					refTimes.current[i].parentNode.className = "sugerido";
					console.log(times, i)
					times[(i+1)+""].price = refTimes.current[i].value = Math.round(costoDia*rel[i]*(Math.pow(.91, i - periodo))*100)/100 || "";
				}
			}
		}
		desglosar();
	}
	const desglosar = ()=>{
		let precioMes = 100;
		const rel = [30,30/7,1,1/12];
		const names = ["day", "week", "month", "year"];
		
		if(times["3"]?.active){
			precioMes = times["3"].price;
		}
		else{
			for(let i = 0; i < 4; i++){
				if(times[(i+1)+""]?.active){
					precioMes = times[(i+1)+""].price*rel[i];
				}
			}
		}
		const comision = .05;
		const impuestos = .16;
		const monto = precioMes*1;
		const aux = {};
		aux["monto"] = Math.round(precioMes*100)/100;
		aux["comision"] = Math.round(monto*comision*100)/100;
		aux["subtotal"] = Math.round((monto - aux["comision"])*100)/100;
		aux["impuestos"] = Math.round(aux["subtotal"]*impuestos*100)/100;
		aux["total"] = Math.round((aux["subtotal"] + aux["impuestos"])*100)/100;
		
		setDesglose(aux);

	}
	const guardarDocsAlmacen = ()=>{
		const results = [];
		let totalArchivos = 0;
		for(let i in archivos){
			if(!archivos[i].file)
				continue;
			const data = new FormData();
			data.append('idStore', id);
			data.append('idDocument', archivos[i].idDocument);
			data.append('file', archivos[i].file);
			
			results.push(
				fetch(baseUrl+"Document/Store", {
					method: "post",
					headers: {
						'Accept': 'application/json',
						'Authorization': `Bearer ${token}`,
					},
					body: data,
				})
				.then(response=>response.json())
				.then(json=>{
					// console.log(json);
					setSubiendo({
						totalArchivos : totalArchivos
					})
					
					archivos[i].file = undefined;
					archivos[i].idStatusDocument = 6;
					setArchivos([...archivos])
					return json;
				})
				.catch(error=>{
					console.error(error);
				})
			)
		}
		Promise.all(results)
		.then(()=>{
			setSubiendo({subidas:0, total : 0, archivosSubidos : 0, totalArchivos : 0})
			setFloatModal({estado:'listo', mensaje:'¡Listo! Se han guardado los cambios con éxito'})
			setTimeout(() => {
				setFloatModal({});
			}, 5000);
			return true;
		})
	}
	const guardarFotosAlmacen = ()=>{
		var results = {
			"fotos": [],
			"eliminarFotos": [],
			"ordenar": [],
		};
		let total = 0;
		for(let k in photos){
			total+= photos[k].reduce((a,b)=> {
				if(b.file)
					return a+1;
				else
					return a+0;
			}, 0);
		}
		let subidas = 0;
		const ordenar = {};
			for(let idCategory in photos){
				photos[idCategory].forEach(photo=>{
					if(photo.uid || !photo.file){
						if(photo.orden!==undefined){
							ordenar[photo.uid] = photo.orden;	
						}
						return false;
					}
					const data = new FormData();
					data.append('idStore', id);
					data.append('idCategoryPhoto', idCategory);
					data.append('file', photo.file);
					data.append('orden', photo.orden);
					
					results["fotos"].push(
						fetch(baseUrl+"Photo/Store", {
							method: "post",
							headers: {
								'Accept': 'application/json',
								'Authorization': `Bearer ${token}`,
							},
							body: data,
						})
						.then(response=>response.json())
						.then(json=>{
							// console.log(json);
							setSubiendo({
								total : total,
								subidas : ++subidas,
							})
							photo.file = undefined;
							return json;
						})
						.catch(error=>{
							console.error(error);
						})
					)
				})	
			}
			results["ordenar"].push(
				fetch(baseUrl+"Photo/Order", {
					method: "put",
					headers: {
						'Content-Type': 'application/json',
						'Accept': 'application/json',
						'Authorization': `Bearer ${token}`,
					},
					body: JSON.stringify({ "photos" : ordenar }),
				})
				.then(response=>response.json())
				.then(json=>{
					return json;
				})
				.catch(error=>{
					console.error(error);
				})
			)
			results["eliminarFotos"].push(
				fetch(baseUrl+"Photo/Store", {
					method: "delete",
					headers: {
						'Content-Type': 'application/json',
						'Accept': 'application/json',
						'Authorization': `Bearer ${token}`,
					},
					body: JSON.stringify({id, "photos":eliminarFotos}),
				})
				.then(response=>response.json())
				.then(json=>{
					return json;
				})
				.catch(error=>{
					console.error(error);
				})
			)
		Promise.all([...results["fotos"], ...results["ordenar"], ...results["eliminarFotos"]])
		.then(()=>{
			setSubiendo({subidas:0, total : 0, archivosSubidos : 0, totalArchivos : 0})
			setFloatModal({estado:'listo', mensaje:'¡Listo! Se han guardado los cambios con éxito'})
			setTimeout(() => {
				setFloatModal({});
			}, 5000);
			return true;
		})
	}
	const guardarAlmacen = async (e)=>{
		if(e?.target)
			e.target.disabled = true;
		setFloatModal({estado:'guardando', mensaje:'Guardando...'})
		const data = {
			"idCompany":0,
			"name":"",
			"locationURL":"",
			"storeArea":"",
			"officeArea":"",
			"storeAreaAvailable":"",
			"totalSpace":"",
			"availableSpace":"",
			"idColony":"0",
			"region":"",
			"street":"",
			"number":"",
			"zipCode":"",
			"idTypeAddress":"1",
			...almacen
		}
		// return false;
		if(id){
			data["idStore"] = id;
		}
		const result = await fetch(baseUrl+"Store/Company", {
			method: "put",
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'Authorization': `Bearer ${token}`,
			},
			body: JSON.stringify(data),
		})
		.then(response=>response.json())
		.then(json=>{
			setFloatModal({estado:'listo', mensaje:'¡Listo! Se han guardado los cambios con éxito'})
			setTimeout(() => {
				setFloatModal({});
			}, 5000);
			if(e?.target)
				e.target.disabled = false;
			return json;
		})
		.catch(error=>{
			console.error(error);
			setFloat({})
			if(e?.target)
				e.target.disabled = false;
		})		
	}
	return(
		<div className="almacen post">
			{modal == 'persona' &&
				<Modal setModal={setModal} titulo={"Subir Archivos Persona"}>
					<Documentos tipo={almacen?.TypeCompany == "Persona fisica" ? "Física" : "Moral"} persona={persona} idCompany={almacen?.idCompany} guardar={guardar}/>
					<div className="btnSubir">
						<button className="btn" onClick={()=>{
							setModal({});
						}}>Cerrar</button>
					</div>
				</Modal>
			}
			
			{modal == 'sinPersona' &&
				<Modal setModal={setModal} titulo={"Asignar Almacén"} className={"asignaModal"}>
					<div className="centraModal">
						{floatModal?.estado &&
							<div className={"float"+(" "+floatModal.estado)}>
								<div className="mensaje">{floatModal.mensaje}</div>
							</div>
						}
						<form>
							<label className="select selectModal">
								<span>Empresa</span>
								<select defaultValue={almacen.idCompany} onChange={(e)=>{
									almacen.idCompany = e.target.value;
								}}>
									<option selected={almacen.idCompany == 0} value={0}>Sin asignar</option>
									{personas.map(persona=>{
										return(
											<option key={persona.idCompany} value={persona.idCompany}>({persona.idtypeCompany == 1 ? "Física" : "Moral"}) {persona.name}</option>
										)
									})
									}
								</select>
							</label>
						</form>
					</div>
					<div className="btnSubir">
						<button className="btn" onClick={guardarAlmacen}>Asignar Almacén</button>
					</div>
				</Modal>
			}
			{modal == 'almacen' &&
				<Modal setModal={setModal} titulo={"Subir Archivos Almacén"}>
					<div>
						{floatModal?.estado &&
							<div className={"float"+(" "+floatModal.estado)}>
								<div className="mensaje">{floatModal.mensaje}</div>
							</div>
						}
						<DocumentosAlmacen almacen={almacen} archivos={docsAlmacen} setArchivos={setDocsAlmacen} requiredOnly={true} guardar={guardarDocsAlmacen}/>
					</div>
					<div className="btnSubir">
						<button className="btn" onClick={()=>{
							setModal({});
						}}>Cerrar</button>
					</div>
				</Modal>
			}
			{modal == 'fotos' &&
				<Modal setModal={setModal} titulo={"Subir Fotos"}>
					<div>
						{floatModal?.estado &&
							<div className={"float"+(" "+floatModal.estado)}>
								<div className="mensaje">{floatModal.mensaje}</div>
							</div>
						}
						<FotosAlmacen almacen={almacen} photos={photos} setPhotos={setPhotos} setEliminarFotos={setEliminarFotos}/>
					</div>
					<div className="btnSubir">
						<button className="btn" onClick={guardarFotosAlmacen}>Subir Fotos</button>
					</div>
				</Modal>
			}
			{((almacen?.idStore && !almacen?.idCompany) ||
			(almacen?.idStore && almacen?.idCompany && archivosInvalidos["persona"].length != 0) ||
			(almacen?.idStore && archivosInvalidos["almacen"].length !== 0) ||
			(almacen?.idStore && totalFotos < 6)
			) && 
				<button className="btnError" onClick={()=>{
					setDetalles(!detalles)
				}}>
					<div>Este Almacén no cumple con los requisitos para ser publicado</div>
					<div>{detalles ? 'Ocultar detalles' : 'Ver detalles'}</div>
				</button>
			}
			{detalles &&
				<div className="detalles">
					{almacen?.idStore && !almacen?.idCompany &&
						<div className="noPublicable" onClick={()=>setModal('sinPersona')}>
							<p className="noPublicable__title">El <b>Almacén</b> no está ligado a una Persona Física o Moral.</p>
							<p className="noPublicable__hint">Esto es necesario para poder publicar almacenes.</p>
						</div>
					}
					{almacen?.idStore && almacen?.idCompany && archivosInvalidos["persona"].length != 0 &&
						<div className="noPublicable" onClick={()=>setModal('persona')}>
							<p className="noPublicable__title">
								La Persona {almacen?.TypeCompany == "Persona fisica" ? "Física" : "Moral"} no tiene estos archivos aprobados
							</p>
							{archivosInvalidos["persona"].length != 0 &&
								<ul className="noPublicable__list">
									{archivosInvalidos["persona"].map(doc=>{
										if(id == 39 && almacen?.TypeCompany != "Persona fisica"){
											return (
												<li key={doc.idDocument}>
													<span>{doc.name} del Representante Legal</span>
													<em className={clases[doc.idStatusDocument]}>{lbls[doc.idStatusDocument]}</em>
												</li>
											)
										}
										return(
											<li key={doc.idDocument}>
												<span>{doc.name}</span>
												<em className={clases[doc.idStatusDocument]}>{lbls[doc.idStatusDocument]}</em>
											</li>
										)
									})
								}
								</ul>
							}
						</div>
					}
					{almacen?.idStore && archivosInvalidos["almacen"].length !== 0 &&
						<div className="noPublicable" onClick={()=>setModal('almacen')}>
							<p className="noPublicable__title">Este Almacén no tiene los archivos aprobados</p>
							{archivosInvalidos["almacen"].length != 0 &&
								<ul className="noPublicable__list">
									{archivosInvalidos["almacen"].map((doc, i)=>{
										return(
											<li key={i}>
												<span>{doc.name}</span>
												<em className={clases[doc.idStatusDocument]}>{lbls[doc.idStatusDocument]}</em>
											</li>
										)
									})
								}
								</ul>
							}
						</div>
					}
					{almacen?.idStore && totalFotos < 6 &&
						<div className="noPublicable" onClick={()=>setModal('fotos')}>
							<p className="noPublicable__title">Este Almacén no tiene las fotos necesarias para publicarse</p>
							<div className="noPublicable__meta">
								<span className="noPublicable__hint">Mínimo 6 fotos</span>
								<span className={totalFotos === 0 ? 'SinSubir' : 'Revision'}>{totalFotos} de 6</span>
							</div>
						</div>
					}
				</div>
			}
			{float?.estado &&
				<div className={"float"+(" "+float.estado)}>
					<div className="mensaje">{float.mensaje}</div>
				</div>
			}
			<div className="opciones">
				{idPost &&
					<Link to={'/almacen/'+idPost} className="btn">Ver publicación</Link>
				}
				<button data-tour="btn-guardar-pub" className="btn" onClick={guardar}>Guardar</button>
			</div>
			{almacen?.idCompany && archivosInvalidos["persona"].length == 0 && archivosInvalidos["almacen"].length == 0 && idPost &&
				<div className="statusPublicacion">
					<button type="button" className={"btn"+(status == 0 ? "" : " apagado")} disabled={disabled} onClick={()=>{
						if(status != 0 && window.confirm("La publicación pasará a 'Sin publicar', ¿Estás seguro?")){
							cambiarStatus(0)
						}
					}}>Sin Publicar</button>
					<button data-tour="btn-publicar-pub" type="button" className={"btn"+(status == 1 ? "" : " apagado")} disabled={disabled} onClick={()=>{
						if(status != 1 && window.confirm("La publicación pasará a 'Publicada', ¿Estás seguro?")){
							cambiarStatus(1)
						}
					}}>Publicada</button>
				</div>
			}
			<div className="pasos">
				<button data-tour="tab-info-pub" className={paso == 'Información' ? 'selected' : ''} onClick={()=>{
					setPaso('Información')
				}}>Información</button>
				<button data-tour="tab-precios-pub" className={paso == 'Precios' ? 'selected' : ''} onClick={()=>{
					setPaso('Precios')
				}}>Precios</button>
				<button data-tour="tab-cancelacion-pub" className={paso == 'Cancelación' ? 'selected' : ''} onClick={()=>{
					setPaso('Cancelación')
				}}>Cancelación</button>
			</div>
			<form>
				{paso == 'Información' &&
					<div>
						<h3>Tipo de Almacenaje</h3>
						<div className="tipos almacenaje">
							{almacen?.TypeStore?.map(id=>{
								return(
									<label key={id}>
										<input type="checkbox" defaultChecked={publicacion.typeOfStores.includes(id)} onChange={(e)=>{
											if(e.target.checked){
												if(publicacion.typeOfStores.indexOf(id) == -1){
													publicacion.typeOfStores.push(id)
												}
											}
											else{
												if(publicacion.typeOfStores.indexOf(id) != -1){
													publicacion.typeOfStores.splice(publicacion.typeOfStores.indexOf(id), 1)
												}
											}
											setPublicacion({...publicacion})
										}}/>
										<div>
											<img src={Imagenes[idsRC[id]]}/>
											<div>{nombres[id]}</div>
											<div className="cuadro">
												<img src={Checked}/>
											</div>
										</div>
									</label>
								)
							})
							}
						</div>
						<div className="confirmacion-row">
							<h4 className="titleConfirmacion">
								<span>Confirmación de Reserva</span>
								<button type='button' className="info" onClick={()=>{
										setInfo('inmediata')
									}}>
									<img src={Info}/>
								</button>
								{info == 'inmediata' &&
									<div className="descHelp" ref={divDesc}>
										<button type='button' className="cerrar" onClick={()=>{
											setInfo('');
										}}>
											<img src={Cerrar}/>
										</button>
										<div>
											<b>Inmediata: </b> En el momento en el que se acredita el pago, se aprueba la reservación de manera automática.
											<br/>
											<b>Consultar Host: </b> Se pide la confirmación del Host antes de aprobar la reservación.
										</div>
									</div>
								}
								</h4>
							<div className="reservacion-buttons">
								<button type="button" className={'reservacion-btn'+(inmediata ? ' sel' : '')} onClick={()=>{
									setInmediata(true)
									publicacion.inmediate = true;
								}}>
									<div className="reservacion-titulo">Inmediata</div>
									<div className="reservacion-espacios">
										<div className="reservacion-col">
											<div className="reservacion-label">Restantes</div>
											<div className="reservacion-numero">{isNaN(almacen?.availableSpace - (inmediata ? ocupados : 0)) ? 0 : almacen?.availableSpace - (inmediata ? ocupados : 0)}</div>
										</div>
										<div className="reservacion-col">
											<div className="reservacion-label">Disponibles</div>
											<div className="reservacion-numero">{isNaN(almacen?.availableSpace) ? 0 : almacen?.availableSpace*1}</div>
										</div>
									</div>
								</button>
								<button type="button" className={'reservacion-btn'+(!inmediata ? ' sel' : '')} onClick={()=>{
									setInmediata(false)
									publicacion.inmediate = false;
								}}>
									<div className="reservacion-titulo">Consultar Host</div>
									<div className="reservacion-espacios">
										<div className="reservacion-col">
											<div className="reservacion-label">Restantes</div>
											<div className="reservacion-numero">{isNaN(almacen?.availableConfirmSpace - (!inmediata ? ocupados : 0)) ? 0 : almacen?.availableConfirmSpace - (!inmediata ? ocupados : 0)}</div>
										</div>
										<div className="reservacion-col">
											<div className="reservacion-label">Disponibles</div>
											<div className="reservacion-numero">{isNaN(almacen?.availableConfirmSpace) ? 0 : almacen?.availableConfirmSpace*1}</div>
										</div>
									</div>
								</button>
							</div>
						</div>
						<div className="infoPublicacion">
							<label>
								<input type="text" minLength={1} placeholder="" defaultValue={publicacion?.name} onChange={(e)=>{
									publicacion.name=e.target.value;
								}} disabled={disabled}/>
								<span>Título de la publicación</span>
							</label>
							<label className="mitad">
								<input type="number" min={1} max={isNaN(inicial*1 + (inmediata ? almacen?.availableSpace : almacen?.availableConfirmSpace)*1 - ocupados) ? 0 : inicial*1 + (inmediata ? almacen?.availableSpace : almacen?.availableConfirmSpace)*1 - ocupados} placeholder="" defaultValue={publicacion?.assignedSpaces} onChange={(e)=>{
									publicacion.assignedSpaces=e.target.value;
									setOcupados(ocupados - (inicial - e.target.value))
									setInicial(e.target.value)
								}} disabled={disabled}/>
								<span>Espacios Asignados</span>
							</label>
							<label className="mitad">
								<input type="number" min={1} placeholder="" defaultValue={publicacion?.width} onChange={(e)=>{
									publicacion.width=e.target.value;
								}} disabled={disabled}/>
								<span>Ancho ({config.sistema=='ingles' ? 'ft' : 'cm'})</span>
							</label>
							<label className="mitad">
								<input type="number" min={1} placeholder="" defaultValue={publicacion?.length} onChange={(e)=>{
									publicacion.length=e.target.value;
								}} disabled={disabled}/>
								<span>Largo ({config.sistema=='ingles' ? 'ft' : 'cm'})</span>
							</label>
							<label className="mitad">
								<input type="number" min={1} placeholder="" defaultValue={publicacion?.height} onChange={(e)=>{
									publicacion.height=e.target.value;
								}} disabled={disabled}/>
								<span>Alto ({config.sistema=='ingles' ? 'ft' : 'cm'})</span>
							</label>
							<label>
								<input type="number" min={1} placeholder="" defaultValue={publicacion?.weight} onChange={(e)=>{
									publicacion.weight = e.target.value;
								}} disabled={disabled}/>
								<span>Capacidad de carga ({config.sistema=='ingles' ? 'lb' : 'kg'})</span>
							</label>
						</div>
					</div>
				}
				{paso == 'Precios' &&
					<div>
						<div className="preciosInOut">
							<div className="precioInOut precioInOut--in">
								<div className="precioInOut__icon" aria-hidden="true">
									<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
										<path d="M12 3v12"/>
										<path d="M8 11l4 4 4-4"/>
										<path d="M5 21h14"/>
									</svg>
								</div>
								<div className="precioInOut__content">
									<span className="precioInOut__label">Precio In</span>
									<div className="precioInOut__field">
										<span className="precioInOut__currency">$</span>
										<input
											type="number"
											min="0"
											step="1"
											defaultValue={publicacion?.priceIn}
											aria-label="Precio In"
											onChange={(e)=>{
												publicacion.priceIn = e.target.value;
											}}
										/>
										<span className="precioInOut__unit">MXN</span>
									</div>
								</div>
							</div>
							<div className="precioInOut precioInOut--out">
								<div className="precioInOut__icon" aria-hidden="true">
									<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
										<path d="M12 21V9"/>
										<path d="M8 13l4-4 4 4"/>
										<path d="M5 3h14"/>
									</svg>
								</div>
								<div className="precioInOut__content">
									<span className="precioInOut__label">Precio Out</span>
									<div className="precioInOut__field">
										<span className="precioInOut__currency">$</span>
										<input
											type="number"
											min="0"
											step="1"
											defaultValue={publicacion?.priceOut}
											aria-label="Precio Out"
											onChange={(e)=>{
												publicacion.priceOut = e.target.value;
											}}
										/>
										<span className="precioInOut__unit">MXN</span>
									</div>
								</div>
							</div>
						</div>
						<h3>Precio por Periodo</h3>
						<div className="infoPrecio">Selecciona uno o varios periodos mínimos de renta</div>
						<div className="tipos precios">
							{periodos.map(periodo=>{
								return(
									<label key={periodo.id}>
										<input type="checkbox" checked={times[periodo.id]?.active} onChange={(e)=>{
											times[periodo.id].active = e.target.checked;
											setTimes({...times});
										}}/>
										<div>
											<div>{periodo.nombre}</div>
										</div>
									</label>
								)
							})
							}
						</div>
						<div className="preciosPost">

							{periodos.map((periodo, i)=>{
								if(times[periodo.id]?.active){
									return(
										<div key={periodo.id} className="precioPost">
											<h4>{periodo.nombre}</h4>
											<div key={periodo.id}>
												<label>
													<input type="number" defaultValue={times[periodo.id].price} ref={ref=>{refTimes.current[i] = ref; return ref;}} onChange={(e)=>{
														if(e.target.value == ""){
															return false;
														}
														times[periodo.id].price = e.target.value*1;
														sugerir(i, e.target.value)
													}} placeholder=""/>
													<span>Precio</span>
												</label>
												
												<label>
													<input type="number" min={1} defaultValue={times[periodo.id].min} onChange={(e)=>{
														if(e.target.value == ""){
															return false;
														}
														times[periodo.id].min = e.target.value*1;
													}} placeholder=""/>
													<span>Periodo mínimo</span>
												</label>
												
												<label>
													<input type="number" defaultValue={times[periodo.id].max} onChange={(e)=>{
														if(e.target.value == ""){
															return false;
														}
														times[periodo.id].max = e.target.value*1;
													}} placeholder=""/>
													<span>Periodo máximo</span>
												</label>

												<label className="select">
													<select defaultValue={times[periodo.id].idTerm} onChange={(e)=>{
														if(e.target.value == ""){
															return false;
														}
														times[periodo.id].idTerm = e.target.value*1;
													}}>
														{terminos?.map(termino=>{
															return(
																<option key={termino.idTerm} value={termino.idTerm} onChange={(e)=>{
																	times[periodo.id].idTerm = e.target.value*1;
																}}>{termino.name}</option>
															)
														})
														}
													</select>
													<span>Crédito</span>
												</label>
												<div className="facturaPost"> Facturación {facturacion[periodo.id]}</div>
											</div>
										</div>
									)
								}
							})}
						</div>
						<div className="desglose">
							<div className="desglose__head">
								<h3>Desglose</h3>
								<p>Estimación mensual de lo que recibirás por esta publicación</p>
							</div>
							<div className="desglose__body">
								<div className="desglose__row">
									<span>Monto</span>
									<strong>{formatoMoneda(desglose?.monto)}</strong>
								</div>
								<div className="desglose__row desglose__row--muted">
									<span>Comisión PalletCloud (5%)</span>
									<strong>-{formatoMoneda(desglose?.comision)}</strong>
								</div>
								<div className="desglose__row">
									<span>Subtotal</span>
									<strong>{formatoMoneda(desglose?.subtotal)}</strong>
								</div>
								<div className="desglose__row desglose__row--muted">
									<span>Impuestos (16%)</span>
									<strong>+{formatoMoneda(desglose?.impuestos)}</strong>
								</div>
							</div>
							<div className="desglose__total">
								<span>Total</span>
								<strong>{formatoMoneda(desglose?.total)}</strong>
							</div>
						</div>
					</div>
				}
				{paso == 'Cancelación' &&
					<div className="cancelacion-section">
						<p className="cancelacion-nota">
							<i>En caso de que el cliente <b>no cancele</b> su reserva, recibirás un <b>anticipo del 20% siete días</b> antes de la fecha de inicio y el resto se abonará en la fecha de inicio.</i>
						</p>
						<h4 className="cancelacion-titulo">Política de Cancelación</h4>
						<div className="cancelacion-lista">
							<button className={'cancelacion-opcion'+(reembolso == 100 ? ' sel' : '')} onClick={()=>{
								setReembolso(100);
							}} type="button">
								<h4>Reembolso Total</h4>
								<p>El cliente puede cancelar hasta <b>7 días</b> antes de la fecha de inicio y en este caso, se le <b>reembolsará el 100%</b> de su pago.</p>
							</button>
							<button className={'cancelacion-opcion'+(reembolso == 50 ? ' sel' : '')} onClick={()=>{
								setReembolso(50);
							}} type="button">
								<h4>Reembolso Parcial</h4>
								<p>El cliente puede cancelar hasta <b>7 días</b> antes de la fecha de inicio y en este caso, se le <b>reembolsará el 50%</b> de su pago.</p>
								<p className="cancelacion-nota-extra"><i>En caso de que el cliente <b>cancele su reserva</b>, recibirás el 50% del pago correspondiente a más tardar <b>7 días hábiles</b> después de la fecha de cancelación.</i></p>
							</button>
							<button className={'cancelacion-opcion'+(reembolso == 0 ? ' sel' : '')} onClick={()=>{
								setReembolso(0);
							}} type="button">
								<h4>Sin Reembolso</h4>
								<p>El cliente no puede cancelar la reservación y de hacerlo, <b>no se le devolverá el pago</b>.</p>
							</button>
						</div>
					</div>
				}
			</form>
		</div>
	);
}
export default Publicacion;